type Options = {
  keys: unknown[];
};

export function getQueryKeyForStudio({ keys }: Options) {
  return ['studio', ...keys];
}
